<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import ScanQRCodeButton from '../components/enter-serial-number/ScanQRCodeButton.vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const manualEnter = () => {
  router.replace({ name: 'SerialNumberManually' });
};

const navigateToStartupSolShare = () => {
  router.replace({ name: 'StartupSolShare' });
};
</script>

<template>
  <ProgressFrame
    pageClass="subsection-page"
    withBackArrow
    :customBackAction="navigateToStartupSolShare"
  >
    <template #title>Enter the SolShare serial number</template>

    <div class="content">
      <p class="instruction-text">The serial number is located on the right side of the unit.</p>

      <ButtonOutlined
        block
        class="manual-button"
        @click="manualEnter"
        data-tn="enter-serial-manually"
      >
        Manually
      </ButtonOutlined>
      <ScanQRCodeButton />
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
:deep(.title__content) {
  max-width: 75%;
}

.instruction-text {
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 2rem;
}

.manual-button {
  margin-bottom: @margin-bottom-button;
}
</style>
